// import React, { useEffect, useState } from 'react';
// import './checkItemSection.css';
// import Img1 from '../../assets/images/sec-1.png';
// import Img2 from '../../assets/images/sec-2.png';
// import Img3 from '../../assets/images/sec-3.png';
// import Img4 from '../../assets/images/sec-4.png';
// import Img5 from '../../assets/images/sec-5.png';
// import { GiCheckMark } from 'react-icons/gi';
// import { ProgressBar } from 'react-bootstrap';

// const CheckItemSection = ({ isRtl }) => {
//     const slideItems = [
//         {
//             text: isRtl
//                 ? 'إعداد مسير الرواتب في دقائق و دفع رواتب الموظفين دون تأخير عن موعد الرواتب المنتظر.'
//                 : 'Prepare payroll in minutes and pay employees salaries without delay beyond the expected payday.',
//             img: Img1,
//         },
//         {
//             text: isRtl
//                 ? 'التوافق مع نظام مكتب العمل الإماراتي بما في ذلك التأمينات الاجتماعية و نظام حماية الأجور.'
//                 : 'Comply with the UAE Ministry of Labor system, including social insurance and the Wage Protection System.',
//             img: Img2,
//         },
//         {
//             text: isRtl
//                 ? 'إدارة إجازات الموظفين و تخصيص أنواع مختلفة من الإجازات بما يتناسب مع احتياجات المنشأة.'
//                 : 'Manage employee leave and allocate different types of leave to suit the needs of the organization.',
//             img: Img3,
//         },
//         {
//             text: isRtl
//                 ? 'تسجيل حظور الموظفين باستخدام أجهزة البصمة أو تطبيقات  إتش آر باس للهاتف المتحرك.'
//                 : 'Record employee attendance using fingerprint devices or HR PASS mobile applications.',
//             img: Img4,
//         },
//         {
//             text: isRtl
//                 ? 'تعزيز تجربة الموظفين و توفير مزايا جديدة من خلال تصبيق إتش آر باس سهل الاستخدام.'
//                 : 'Enhance the employee experience and provide new benefits through the easy-to-use HR PASS app.',
//             img: Img5,
//         },
//     ];

//     const [currentSlide, setCurrentSlide] = useState(0);
//     const [progress, setProgress] = useState(0);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setProgress((prev) => {
//                 if (prev >= 100) {
//                     setCurrentSlide((prevSlide) => (prevSlide + 1) % slideItems.length);
//                     return 0;
//                 }
//                 return prev + 1;
//             });
//         }, 100);

//         return () => clearInterval(interval);
//     }, [slideItems.length]);

//     return (
//         <section className={`checkItemSection ${isRtl ? 'rtl' : ''}`}>
//             <div className="container-fluid containerSpacing">
//                 <div className="row align-items-stretch">
//                     <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-md-2 order-2">
//                         {/* <div className="progresBox">
//                             <ProgressBar now={progress} />
//                         </div> */}
//                         <div className="content-box" data-aos-easing="ease-in-out" data-aos="fade-right">
//                             <h2>
//                                 {isRtl
//                                     ? 'تمكنك منصة إتش آر باس المتكاملة لإدارة الموارد البشرية من:'
//                                     : 'The integrated HR PASS platform allows you to:'}
//                             </h2>
//                             {slideItems.map((item, index) => (
//                                 <div
//                                     className={`slideItem ${index === currentSlide ? 'active' : ''
//                                         }`}
//                                     key={index}
//                                 >
//                                     <GiCheckMark />
//                                     <p className="title">{item.text}</p>
//                                 </div>
//                             ))}

//                             <a href="" className="darkBrownBtn">
//                                 {isRtl ? 'اطلب عرض تجريبي' : 'Request a Demo'}
//                             </a>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-md-1 order-1">
//                         <div className="img-box" data-aos-easing="ease-in-out" data-aos="fade-left">
//                             <img
//                                 src={slideItems[currentSlide]?.img || Img1}
//                                 alt=""
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CheckItemSection;




// import React, { useEffect, useState, useRef } from 'react';
// import './checkItemSection.css';
// import Img1 from '../../assets/images/sec-1.png';
// import Img2 from '../../assets/images/sec-2.png';
// import Img3 from '../../assets/images/sec-3.png';
// import Img4 from '../../assets/images/sec-4.png';
// import Img5 from '../../assets/images/sec-5.png';
// import { GiCheckMark } from 'react-icons/gi';
// import { ProgressBar } from 'react-bootstrap';

// const CheckItemSection = ({ isRtl }) => {
//     const slideItems = [
//         {
//             text: isRtl
//                 ? 'إعداد مسير الرواتب في دقائق و دفع رواتب الموظفين دون تأخير عن موعد الرواتب المنتظر.'
//                 : 'Prepare payroll in minutes and pay employees salaries without delay beyond the expected payday.',
//             img: Img1,
//         },
//         {
//             text: isRtl
//                 ? 'التوافق مع نظام مكتب العمل الإماراتي بما في ذلك التأمينات الاجتماعية و نظام حماية الأجور.'
//                 : 'Comply with the UAE Ministry of Labor system, including social insurance and the Wage Protection System.',
//             img: Img2,
//         },
//         {
//             text: isRtl
//                 ? 'إدارة إجازات الموظفين و تخصيص أنواع مختلفة من الإجازات بما يتناسب مع احتياجات المنشأة.'
//                 : 'Manage employee leave and allocate different types of leave to suit the needs of the organization.',
//             img: Img3,
//         },
//         {
//             text: isRtl
//                 ? 'تسجيل حظور الموظفين باستخدام أجهزة البصمة أو تطبيقات  إتش آر باس للهاتف المتحرك.'
//                 : 'Record employee attendance using fingerprint devices or HR PASS mobile applications.',
//             img: Img4,
//         },
//         {
//             text: isRtl
//                 ? 'تعزيز تجربة الموظفين و توفير مزايا جديدة من خلال تصبيق إتش آر باس سهل الاستخدام.'
//                 : 'Enhance the employee experience and provide new benefits through the easy-to-use HR PASS app.',
//             img: Img5,
//         },
//     ];

//     const [currentSlide, setCurrentSlide] = useState(0);
//     const [progress, setProgress] = useState(0);
//     const [isVisible, setIsVisible] = useState(false);
//     const [isPaused, setIsPaused] = useState(false);
//     const [fade, setFade] = useState(false);
//     const sectionRef = useRef(null);

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 setIsVisible(entry.isIntersecting);
//             },
//             { threshold: 0.5 }
//         );

//         if (sectionRef.current) {
//             observer.observe(sectionRef.current);
//         }

//         return () => {
//             if (sectionRef.current) {
//                 observer.unobserve(sectionRef.current);
//             }
//         };
//     }, []);

//     useEffect(() => {
//         let interval;
//         if (isVisible && !isPaused) {
//             interval = setInterval(() => {
//                 setProgress((prev) => {
//                     if (prev >= 100) {
//                         setCurrentSlide((prevSlide) => (prevSlide + 1) % slideItems.length);
//                         return 0;
//                     }
//                     return prev + 1;
//                 });
//             }, 100);
//         }

//         return () => clearInterval(interval);
//     }, [isVisible, isPaused, slideItems.length]);

//     const changeSlide = (index) => {
//         setFade(true);
//         setTimeout(() => {
//             setCurrentSlide(index);
//             setFade(false);
//         }, 300); // Duration matches the fade-out effect
//     };

//     const handleItemClick = (index) => {
//         setIsPaused(true); // Pause the slideshow
//         changeSlide(index);
//         setCurrentSlide(index); // Set the clicked item as active
//         setProgress(0); // Reset progress
//     };

//     return (
//         <section
//             className={`checkItemSection ${isRtl ? 'rtl' : ''}`}
//             ref={sectionRef}
//         >
//             <div className="container-fluid containerSpacing">
//                 <div className="row align-items-stretch">
//                     <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-md-2 order-2">
//                         <div className="progresBox">
//                             <ProgressBar now={progress} />
//                         </div>
//                         <div className="content-box"
//                         //  data-aos-easing="ease-in-out" data-aos="fade-right"
//                          >
//                             <h2>
//                                 {isRtl
//                                     ? 'تمكنك منصة إتش آر باس المتكاملة لإدارة الموارد البشرية من:'
//                                     : 'The integrated HR PASS platform allows you to:'}
//                             </h2>
//                             {slideItems.map((item, index) => (
//                                 <div
//                                     className={`slideItem ${index === currentSlide ? 'active' : ''}`}
//                                     key={index}
//                                     onClick={() => handleItemClick(index)} // Set item on click
//                                     style={{ cursor: 'pointer' }}
//                                 >
//                                     <GiCheckMark />
//                                     <p className="title">{item.text}</p>
//                                 </div>
//                             ))}

//                             <a href="" className="darkBrownBtn">
//                                 {isRtl ? 'اطلب عرض تجريبي' : 'Request a Demo'}
//                             </a>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-md-1 order-1">
//                         <div 
//                         // className="img-box"
//                             className={`img-box ${fade ? 'fade' : ''}`} 
//                         // data-aos-easing="ease-in-out" data-aos="fade-left"
//                         >
//                             <img
//                                 src={slideItems[currentSlide]?.img || Img1}
//                                 alt=""
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CheckItemSection;




import React, { useEffect, useState, useRef } from 'react';
import './checkItemSection.css';
import Img1 from '../../assets/images/01.jpg';
import Img2 from '../../assets/images/02.jpg';
import Img3 from '../../assets/images/03.jpg';
import Img4 from '../../assets/images/04.jpg';
import Img5 from '../../assets/images/05.jpg';
import { GiCheckMark } from 'react-icons/gi';
import { ProgressBar } from 'react-bootstrap';

const CheckItemSection = ({ isRtl }) => {
    const slideItems = [
        {
            text: isRtl
                ? 'إعداد مسير الرواتب في دقائق و دفع رواتب الموظفين دون تأخير عن موعد الرواتب المنتظر.'
                : 'Prepare payroll in minutes and pay employees salaries without delay beyond the expected payday.',
            img: Img1,
        },
        {
            text: isRtl
                ? 'التوافق مع نظام مكتب العمل الإماراتي بما في ذلك التأمينات الاجتماعية و نظام حماية الأجور.'
                : 'Comply with the UAE Ministry of Labor system, including social insurance and the Wage Protection System.',
            img: Img2,
        },
        {
            text: isRtl
                ? 'إدارة إجازات الموظفين و تخصيص أنواع مختلفة من الإجازات بما يتناسب مع احتياجات المنشأة.'
                : 'Manage employee leave and allocate different types of leave to suit the needs of the organization.',
            img: Img3,
        },
        {
            text: isRtl
                ? 'تسجيل حظور الموظفين باستخدام أجهزة البصمة أو تطبيقات  إتش آر باس للهاتف المتحرك.'
                : 'Record employee attendance using fingerprint devices or HR PASS mobile applications.',
            img: Img4,
        },
        {
            text: isRtl
                ? 'تعزيز تجربة الموظفين و توفير مزايا جديدة من خلال تصبيق إتش آر باس سهل الاستخدام.'
                : 'Enhance the employee experience and provide new benefits through the easy-to-use HR PASS app.',
            img: Img5,
        },
    ];

    const [currentSlide, setCurrentSlide] = useState(0);
    const [progress, setProgress] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [fade, setFade] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        let interval;

        if (isVisible && !isPaused && !fade) {
            interval = setInterval(() => {
                setProgress((prev) => {
                    if (prev >= 120) {
                        changeSlide((currentSlide + 1) % slideItems.length);
                        return 0;
                    }
                    return prev + 1;
                });
            }, 50);
        }

        return () => clearInterval(interval);
    }, [isVisible, isPaused, fade]);



    const changeSlide = (index) => {
        setFade(true); // Trigger fade-out
        setTimeout(() => {
            setCurrentSlide(index); // Update the slide
            // setFade(false);
            setTimeout(() => setFade(false), 300);
        }, 300); // Match CSS transition duration
    };

    const handleItemClick = (index) => {
        setIsPaused(true);
        changeSlide(index);
        setProgress(0);
    };

    return (
        <section className={`checkItemSection ${isRtl ? 'rtl' : ''}`} ref={sectionRef}>
            <div className="">
                <div className="row align-items-stretch">
                    <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-md-2 order-2">
                        <div className="ccBox">
                            <div className="progresBox">
                                <ProgressBar now={progress} />
                            </div>
                            <div className="content-box">
                                <h2>
                                    {isRtl
                                        ? 'تمكنك منصة إتش آر باس المتكاملة لإدارة الموارد البشرية من:'
                                        : 'The integrated HR PASS platform allows you to:'}
                                </h2>
                                {slideItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`slideItem ${index === currentSlide ? 'active' : ''}`}
                                        onClick={() => handleItemClick(index)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <GiCheckMark />
                                        <p className="title">{item.text}</p>
                                    </div>
                                ))}
                                <a href="" className="darkBrownBtn">
                                    {isRtl ? 'اطلب عرض تجريبي' : 'Request a Demo'}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-md-1 order-1">
                        <div className={`img-box ${fade ? 'fade' : ''}`}>
                            <img src={slideItems[currentSlide]?.img || Img1} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CheckItemSection;
